window.rebuild = false;

window.UUID = UUID = () => {
    var d = new Date().getTime();
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

window.refreshCartAttributes = refreshCartAttributes = async () => {
    return new Promise(async (resolve, reject) => {
        const stroetmannCart = await fetch('/cart?view=json');
        const { current_user, current_date, current_user_alias } = await stroetmannCart.json();
        const formData = new FormData();
        if (!current_user) {
            formData.append('attributes[login_refresh]', 'false');
            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Bypass-Internal': 'true',
                        'No-Queue': 'true'
                    },
                    body: formData,
                });
            } catch (error) {
                console.error('Error clearing cart attributes before logout:', error);
            }
            window.location.href = '/account/logout';
            return;
        }
        formData.append('attributes[current_date]', current_date);
        formData.append('attributes[current_user]', current_user);
        formData.append('attributes[login_refresh]', 'false');
        if(current_user_alias) formData.append('attributes[current_user_alias]', current_user_alias);
        try {
            const updateResponse = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Bypass-Internal': 'true',
                    'No-Queue': 'true'
                },
                body: formData,
            });
            
            if (!updateResponse.ok) {
                console.error('Cart update failed:', updateResponse.status);
                const errorText = await updateResponse.text();
                console.error('Error details:', errorText);
                
                // Still resolve to prevent blocking the rebuild process
                // The cart might still be functional even if attribute update fails
                resolve();
                return;
            }
        } catch (error) {
            console.error('Error updating cart attributes:', error);
            // Still resolve to prevent blocking the rebuild process
            resolve();
            return;
        }
        resolve();
    });
}

window.refreshCart = refreshCart = async () => {
    const cartUpdatedPricesRequest = await fetch('/cart?view=rebuild');
    const cartUpdatedPricesResponse = await cartUpdatedPricesRequest.json();
    const shopifyCartRequest = await fetch('/cart.json');
    const shopifyCartResponse = await shopifyCartRequest.json();
    if (shopifyCartResponse.items.length == 0) {
        return;
    }
    const cartAddBody = {
        items: []
    };
    await fetch(`${theme.routes.cartClear}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'No-Queue': 'true'
        }
    });
    shopifyCartResponse.items.forEach(({ variant_id, quantity, variant_identifier, properties }) => {
        const updatedItem = cartUpdatedPricesResponse.items.find(({ variant_id: updatedVariantId }) => updatedVariantId == variant_id);
        updatedItem && cartAddBody.items.push({
            id: variant_id,
            quantity: quantity,
            properties: {
                ...properties,
                '_price': `${updatedItem.price}`,
            }
        });
    })
    if (cartAddBody.items.length > 0) {
        await fetch(`${theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'No-Queue': 'true'
            },
            body: JSON.stringify(cartAddBody)
        });
    }
    return;
}

window.rebuildPartial = sendAddItems = async (items) => {
    return fetch(`${theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true'
        },
        body: JSON.stringify({ items: items }),
    })
}

window.rebuildPartial = rebuildPartial = async (items, added = 0, dummy = 0) => {
    return new Promise(async (resolve) => {
        let currentBucket = items.slice(0, 100);
        const nextItems = items.filter((item) => ![...currentBucket.map((bucket) => bucket.id)].includes(item.id));
        dummy = await window.renewDummyItems(added + currentBucket.length, dummy);
        const partialAdd = await sendAddItems(currentBucket);
        const partialAddResponse = await partialAdd.json();
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        if (nextItems.length) {
            await rebuildPartial(nextItems, added + currentBucket.length, dummy);
        }
        resolve();
    })
}

window.rebuildCart = rebuildCart = async () => {
    return new Promise(async (resolve) => {
        document.querySelectorAll(`quantity-input`).forEach((el) => {
            el.querySelector('.qty-input__input').disabled = true;
            el.querySelector('.btn--minus').disabled = true;
            el.querySelector('.btn--plus').disabled = true;
        });
        await window.clearDiscounts();
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        
        try {
            await window.clearCartAtributes();
        } catch (error) {
            console.warn('Cart attributes clear failed during rebuild, continuing:', error);
        }
        
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        
        try {
            await window.refreshCartAttributes();
        } catch (error) {
            console.warn('Cart attributes refresh failed during rebuild, continuing:', error);
        }
        
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        const response = await fetch('/cart?view=json', {
            headers: {
                'Content-Type': 'application/json',
                'Bypass-Internal': 'true',
                'No-Queue': 'true'
            }
        });
        let { lines } = await response.json();
        const items = lines.filter(({ product_id }) => window.settings.dummy.product_id != product_id);
        if (items.length == 0) {
            document.querySelectorAll(`quantity-input`).forEach((el) => {
                el.querySelector('.qty-input__input').disabled = false;
                el.querySelector('.btn--minus').disabled = false;
                el.querySelector('.btn--plus').disabled = false;
            });
            return resolve();
        }
        items.forEach(({ variantId, quantity }) => {
            const qtyInput = document.querySelector(`.qty-input__input[data-variant-id="${variantId}"]`);
            if (qtyInput) {
                qtyInput.closest('quantity-input').classList.add('in-cart');
                qtyInput.value = quantity;
            }
        });
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        if (items.length >= 100) {
            document.dispatchEvent(new CustomEvent('queue-job:increase-max', { bubbles: true, detail: Math.round(items.length / 100) }));
            await rebuildPartial(items.map(({ variantId, quantity, properties }) => {
                return {
                    id: variantId,
                    quantity: quantity,
                    properties
                }
            }));
            const cartReq = await fetch('/cart.json', {
                headers: {
                    'Content-Type': 'application/json',
                    'Bypass-Internal': 'true',
                    'No-Queue': 'true'
                }
            });
            const cartRes = await cartReq.json();
            document.querySelector('[data-cart-items]').innerText = JSON.stringify(cartRes.items);
        } else {
            const addRequest = await sendAddItems(items.map(({ variantId, quantity, properties }) => {
                return {
                    id: variantId,
                    quantity: quantity,
                    properties
                }
            }));
            // const addResponse = await addRequest.json();
            document.querySelector('[data-cart-items]').innerText = JSON.stringify(addRequest.items);
        }
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        await window.render();
        document.querySelectorAll(`quantity-input`).forEach((el) => {
            el.querySelector('.qty-input__input').disabled = false;
            el.querySelector('.btn--minus').disabled = false;
            el.querySelector('.btn--plus').disabled = false;
        });
        document.dispatchEvent(new CustomEvent('queue-job:step', { bubbles: true }));
        return resolve();
    })
}

window.clearDiscounts = clearDiscounts = async () => {
    const request = await fetch(`${window.theme.routes.cart}.js`, {
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true'
        }
    });
    const cart = await request.json();
    const token = document.querySelector('body').dataset.token;
    const query = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                        id
                        discountCodes {
                            code
                        }
                    }
                    userErrors {
                        field
                        message
                    }
                    warnings {
                        code
                        message
                    }
                }
            }`;
    const variables = {
        "cartId": `gid://shopify/Cart/${cart.token}`,
        "discountCodes": []
    };
    return fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Bypass-Internal': 'true',
            'No-Queue': 'true',
            'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: query, variables: variables })
    });
}

// Global helper function to generate cart headers with customer ID
window.getCartHeaders = function(additionalHeaders = {}) {
    const headers = {
        'Content-Type': 'application/json',
        ...additionalHeaders
    };
    
    // Add customer ID header if customer is logged in
    if (window.customer && window.customer.id) {
        headers['X-Custom-Customer-ID'] = window.customer.id.toString();
    }

    if (window.customer && window.customer.userName) {
        headers['X-Custom-User-Name'] = window.customer.userName.toString();
    }

    if (window.customer && window.customer.currentUserNumber) {
        headers['X-Custom-User-Number'] = window.customer.currentUserNumber.toString();
    }
    
    return headers;
};

window.clearCartAtributes = clearCartAtributes = async (clearUser = false) => {
    localStorage.removeItem('checkout_update_at');
    localStorage.removeItem('related_products');
    localStorage.removeItem('checkout_timeout');
    localStorage.removeItem('checkout_update_checkout_timeout');
    localStorage.removeItem('checkout_progress');
    localStorage.removeItem('checkout_approved');
    localStorage.removeItem('username_key');
    localStorage.removeItem('checkoutId');
    localStorage.removeItem('checkout');
    if (window.customer && window.customer.currentUserNumber) {
        localStorage.removeItem(`${window.customer.currentUserNumber}_bonus_response`);
        localStorage.removeItem(`${window.customer.currentUserNumber}_bonus_balance`);
    }
    
    // DO NOT clear the entire cart - only clear attributes and user identification in note
    const formData = new FormData();
    formData.append('attributes[locked]', '');
    formData.append('attributes[expires_at]', '');
    formData.append('attributes[total_before]', '');
    formData.append('attributes[bonus_amount]', '');
    formData.append('attributes[alternatives]', '');
    formData.append('attributes[terms_1_checked]', '');
    formData.append('attributes[terms_2_checked]', '');
    formData.append('attributes[terms_3_checked]', '');
    formData.append('attributes[offline_checkout_accepted]', '');
    formData.append('attributes[offline_checkout_canceled]', '');
    
    if (clearUser) {
        // Clear user identification from note field while preserving actual user note
        try {
            // Get current cart to extract actual user note
            const cartResponse = await fetch('/cart.js');
            const currentCart = await cartResponse.json();
            
            let preservedNote = '';
            if (currentCart.note) {
                const noteParts = currentCart.note.split('|');
                // If note contains our pipe-separated format, preserve only the actual note part
                if (noteParts.length > 3) {
                    preservedNote = noteParts.slice(3).join('|');
                } else if (!currentCart.note.includes('|') || noteParts.length < 3) {
                    // If note doesn't contain our format, preserve the entire note
                    preservedNote = currentCart.note;
                }
            }
            
            // Set the preserved note (without user identification)
            formData.append('note', preservedNote);
        } catch (error) {
            console.warn('Could not preserve user note during cart attributes clearing:', error);
            formData.append('note', ''); // Clear note entirely if we can't parse it
        }
        
        // Clear user-related attributes
        formData.append('attributes[current_date]', '');
        formData.append('attributes[username_key]', '');
        formData.append('attributes[current_user]', '');
        formData.append('attributes[current_user_alias]', '');
    }
    // If clearUser is false, don't modify the note field at all
    
    const headers = window.getCartHeaders({
        'Bypass-Internal': 'true',
        'No-Queue': 'true',
    });
    
    try {
        const response = await fetch(`${window.theme.routes.cartUpdate}.js`, {
            method: 'POST',
            headers: headers,
            body: formData,
        });
        
        if (!response.ok) {
            console.warn(`Cart attributes clear returned ${response.status}, but continuing...`);
            // Don't throw error - cart might still be functional
        }
        
        return response;
    } catch (error) {
        console.warn('Cart attributes clear failed, but continuing:', error);
        // Return a mock successful response to prevent blocking
        return { ok: true, json: async () => ({}) };
    }
}

window.render = render = async () => {
    if (window.location.pathname == '/cart') {
        return window.checkout.render();
    }
    return new Promise(async (resolve, reject) => {
        const isCartPage = document.querySelector('body')?.dataset.pageType == 'cart';
        const cartItemSectionId = isCartPage ? document.getElementById('cart-items').dataset.section : null;
        const sections = [
            'cart-icon-bubble'
        ];
        if (isCartPage) {
            sections.push(cartItemSectionId);
        }
        const addResponse = await fetch(`/cart?sections=${sections.join(',')}&sections_url=${window.location.pathname}`);
        const addResponseJson = await addResponse.json();
        const cartIconTemplate = document.createElement('template');
        cartIconTemplate.innerHTML = addResponseJson['cart-icon-bubble'];
        const cartIconBubbleEl = cartIconTemplate.content.querySelector('#shopify-section-cart-icon-bubble');
        cartIconBubbleEl.querySelector('.cart-icon-bubble-loading').classList.remove('hidden');
        document.querySelector('#cart-icon-bubble').innerHTML = cartIconBubbleEl.innerHTML;
        if (isCartPage) {
            const mainCartTemplate = document.createElement('template');
            mainCartTemplate.innerHTML = addResponseJson[cartItemSectionId];;
            const mainCartEl = mainCartTemplate.content.querySelector(`#shopify-section-${cartItemSectionId}`);
            document.querySelector('.cc-main-cart').innerHTML = mainCartEl.innerHTML;
        }
        return resolve();
    });
}

window.calculateDummyCount = calculateDummyCount = (positionCount) => {

    const minPositionCount = parseInt(window.settings.dummy.start_at_position); // wanted to start adding dummies from 100 positions -> sin curve based on this
    const maxPositionCount = parseInt(window.settings.dummy.stop_at_position); // wanted to have 0 dummies by having 300 positions -> sin curve based on this

    if (positionCount < minPositionCount || positionCount >= maxPositionCount) {
        return 0;
    }

    const x = positionCount; // x side of the graph
    const M = parseInt(window.settings.dummy.dummy_formula_m); // Max dummy count result
    const s = window.settings.dummy.dummy_formula_s * 1; // Left right sinus shift
    const d = window.settings.dummy.dummy_formula_d * 1; // Dummy count change speed

    const targetDummyCount = (M * 0.5) * Math.sin(x * 2 / d + s) + (M * 0.5);

    console.log({
        x: x,
        y: targetDummyCount
    })

    return targetDummyCount;
}

window.renewDummyItems = renewDummyItems = async (positionCount, dummyCount) => {
    return new Promise(async (resolve, reject) => {

        if (!window.settings.dummy.enabled) {
            return resolve();
        }

        let adjustBy = 0;

        const updatedStore = JSON.parse(document.querySelector('[data-cart-items]').innerText);

        if (!window.settings.dummy.sin_enabled) {
            const dynamicLimitThreshold = 200;
            const maxDummyCount = 200;
            // const dummyItemList = updatedStore.filter(({ product_id }) => [window.settings.dummy.product_id].includes(product_id));
            // const productItemList = updatedStore.filter(({ product_id }) => ![window.settings.dummy.product_id].includes(product_id));
            const requiredDummyCount = dynamicLimitThreshold - positionCount;
            const calculatedBuffer = Math.round((positionCount - 100) / 100 * maxDummyCount);
            adjustBy = positionCount < 100 && dummyCount > 0 ? dummyCount * -1 :
                positionCount >= 280 && dummyCount > 0 ? -1 :
                    dummyCount < maxDummyCount && positionCount >= 100 && positionCount <= 200 ?
                        requiredDummyCount + calculatedBuffer - dummyCount :
                        0;
        } else {
            const calculatedDummyTotalCount = window.calculateDummyCount(positionCount);
            const intDummyCount = Math.round(calculatedDummyTotalCount);
            adjustBy = intDummyCount - dummyCount;
        }

        if (adjustBy > 0) {
            const items = Array
                .from({ length: adjustBy }, (x, i) => i)
                .map((id) => {
                    return {
                        id: window.settings.dummy.variant_id,
                        quantity: 1,
                        properties: {
                            unique_identifier: window.UUID()
                        }
                    }
                });
            const add = await window.retryableFetch({
                args: [`${window.theme.routes.cartAdd}.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Bypass-Internal': 'true',
                        'No-Queue': 'true',
                    },
                    body: JSON.stringify({ items: items })
                }]
            });
            const addJson = await add.json();
            document.querySelector('[data-cart-items]').innerText = JSON.stringify([...updatedStore, ...addJson.items]);
        }
        if (adjustBy < 0) {
            const inCartDummies = updatedStore.filter(({ product_id }) => window.settings.dummy.product_id == product_id);
            const removedItems = [];
            const formData = new FormData();
            for (let i = 0; i < inCartDummies.slice(0, adjustBy * -1).length; i++) {
                formData.append(`updates[${inCartDummies[i].key}]`, 0);
            }
            await window.retryableFetch({
                args: [`${window.theme.routes.cartUpdate}.js`, {
                    method: 'POST',
                    headers: {
                        'Bypass-Internal': 'true',
                        'No-Queue': 'true',
                    },
                    body: formData
                }]
            });
            document.querySelector('[data-cart-items]').innerText = JSON.stringify(updatedStore.filter(({ key }) => !removedItems.includes(key)));
        }
        return resolve(adjustBy);
    });
}

window.priceValidation = priceValidation = async () => {
    const items = JSON.parse(document.querySelector('[data-cart-items]').innerText);
    const hasMissingPriceItems = items
        .filter(({ product_id }) => window.settings.dummy.product_id != product_id)
        .filter(({ properties }) => Object.keys(properties).includes('_unique_identifier'))
        .filter(({ properties }) => !Object.keys(properties).includes('_price') || (Object.keys(properties).includes('_price') && properties['_price'] == 0));
    if (hasMissingPriceItems.length) {
        await refreshCart();
        await render();
    }
}

window.queueActive = queueActive = () => {
    return window.fetchQueue ? window.fetchQueue.running : false;
}

document.addEventListener('DOMContentLoaded', async () => {
    
    // Clear reload blocks on successful page load (after a successful session)
    const timeSinceLastReload = Date.now() - parseInt(sessionStorage.getItem('last_page_load_time') || '0');
    if (timeSinceLastReload > 30000) { // 30 seconds since last reload attempt
        sessionStorage.removeItem('user_number_reload_blocked');
        sessionStorage.removeItem('user_number_reload_count');
    }
    sessionStorage.setItem('last_page_load_time', Date.now().toString());

    await window.priceValidation();

    await new Promise((resolve) => { setTimeout(() => { resolve() }, 500); });

    if (window.queueActive()) {
        return;
    }

    const isTempUser = window.customer?.currentUserNumber?.startsWith('b2b_');
    const locked = document.querySelector('body').dataset.cartLocked == 'true';
    const checkoutPresent = document.querySelector('body').dataset.checkoutPresent == 'true';
    const rebuild = document.querySelector('body').dataset.rebuildCart == 'true';
    const hasCurrentUser = document.querySelector('body').dataset.hasCurrentUser == 'true';
    const hasCurrentDate = document.querySelector('body').dataset.hasCurrentDate == 'true';
    const userNumberPresent = document.querySelector('body').dataset.userNumberPresent == 'true';
    const cartItemLength = parseInt(document.querySelector('body').dataset.cartItemLength);

    const checkoutRebuildRequired = window.rebuildCheckoutRequired();

    const shouldRebuild = !isTempUser && !checkoutPresent && rebuild && !checkoutRebuildRequired && !window.queueActive();

    if (window.customer == null && hasCurrentUser) {
        window.clearCartAtributes(true);
        return;
    }

    if (!userNumberPresent && window.customer !== null) {
        // Prevent endless reloading with safety check
        const reloadCount = parseInt(sessionStorage.getItem('user_number_reload_count') || '0');
        if (reloadCount >= 3) {
            console.error('🚨 Too many user number reloads, stopping to prevent infinite loop');
            sessionStorage.setItem('user_number_reload_blocked', 'true');
            return;
        }
        
        if (sessionStorage.getItem('user_number_reload_blocked') === 'true') {
            console.log('🔄 User number reload blocked due to previous failures');
            return;
        }
        
        sessionStorage.setItem('user_number_reload_count', (reloadCount + 1).toString());
        
        document.getElementById('cart-icon-bubble').classList.add('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('queue-job:show', { bubbles: true, detail: 1 }));
        await window.refreshCartAttributes();
        window.location.reload();
        return;
    }

    if (!hasCurrentDate) {
        if (window.location.pathname != '/pages/thank-you' && cartItemLength) {
            document.dispatchEvent(new CustomEvent('main-calendar:on:open', { bubbles: true }));
        }
        return;
    }

    if (!shouldRebuild || locked) {
        return;
    }

    // Use smart cart sync instead of heavy rebuildCart
    if (window.smartCartSync) {
        console.log('🔄 Using smart cart sync instead of rebuildCart');
        await window.smartCartSync.performMinimalSync();
        return;
    }

    // Fallback to old method if smart sync not available
    window.rebuild = true;

    try {

        document.getElementById('cart-icon-bubble').classList.add('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.remove('hidden');

        document.dispatchEvent(new CustomEvent('queue-job:show', { bubbles: true, detail: 6 }));

        await window.rebuildCart();

        window.rebuild = false;
        document.querySelector('body').dataset.rebuildCart = 'false';

        document.getElementById('cart-icon-bubble').classList.remove('loading');
        document.querySelector('.cart-icon-bubble-loading').classList.add('hidden');

        document.dispatchEvent(new CustomEvent('queue-job:end', { bubbles: true }));

    } catch (e) {
        const modalWindow = document.getElementById('checkout-response-error');
        if (modalWindow) {
            modalWindow.html = `File: <b>common-cart.js</b><br /><br /><hr style="margin: 10px 0 5px;" />`;
            modalWindow.message = e;
            modalWindow.stack = e.stack;
            modalWindow.open();
        }
    }
});